/*
Volume Calculator with Up/Down Classification
Classifies volume bars as up (green) or down (red) based on price direction
*/

export default function () {
  let options = {
    volumePath: "volume",
  };

  // #440: desktop antigo pode ter o indicador salvo sem `config` — aí o
  // renderKey É "volume" e a saída {volume, direction} mora no mesmo campo que
  // a entrada, colisão que calculators.js não tem como evitar. Desembrulhar na
  // leitura, como já fazem mfi/klinger/accumDist/chaikinMoneyFlow.
  const unwrap = (raw) =>
    typeof raw === "object" && raw !== null ? raw.volume : raw;

  function calculator(data) {
    return data.map((d, i) => {
      const volume = unwrap(d[options.volumePath]);

      const direction =
        i === 0 ? "up" : d.close >= data[i - 1].close ? "up" : "down";

      return { volume, direction };
    });
  }

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...options, ...x };
    return calculator;
  };

  calculator.undefinedLength = function () {
    return 0; // No warmup period needed
  };

  return calculator;
}
